interface IAppConst {
    headerHeight: number,
    baseApiURL: string
}
export const appConst: IAppConst = {
    headerHeight: 56,
    baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() ?? ""
}